import React from 'react';

import { compose } from 'redux';

import { SyncIntegrationNames } from 'common/constants/autopilotIntegrations';
import withAccessControl from 'common/routing/withAccessControl';
import AdminIntegrationSettings from 'common/subdomain/admin/AdminIntegrationSettings/AdminIntegrationSettings';
import { AutopilotIntegrations } from 'common/subdomain/admin/AdminIntegrationSettings/constants';
import { ZapierSources } from 'common/subdomain/admin/AdminQueue/GettingStarted/constants';
import { RoutePermissions, testEveryPermission } from 'common/util/permissions';

export const getAutopilotSectionIntegrations = ({ includeZapier } = { includeZapier: false }) => {
  return [...AutopilotIntegrations, ...(includeZapier ? ZapierSources : [])];
};

const AdminIntegrationSettingsAutopilot = () => {
  const publicReviewIntegrationNames = [
    SyncIntegrationNames.appStoreReviews,
    SyncIntegrationNames.capterraReviews,
    SyncIntegrationNames.g2Reviews,
    SyncIntegrationNames.playStoreReviews,
    SyncIntegrationNames.productHuntReviews,
    SyncIntegrationNames.salesforceReviews,
    SyncIntegrationNames.shopifyReviews,
    SyncIntegrationNames.trustpilotReviews,
    SyncIntegrationNames.trustradiusReviews,
    SyncIntegrationNames.wordpressReviews,
  ];
  const allIntegrations = getAutopilotSectionIntegrations();
  const publicReviewIntegrations = allIntegrations.filter(({ name }) =>
    publicReviewIntegrationNames.includes(name),
  );
  const otherIntegrations = allIntegrations.filter(
    ({ name }) => !publicReviewIntegrationNames.includes(name),
  );

  const sections = [
    {
      integrations: otherIntegrations,
    },
    {
      sectionTitle: 'Public Reviews',
      integrations: publicReviewIntegrations,
    },
    {
      sectionTitle: 'Zapier Templates',
      integrations: ZapierSources,
    },
  ];

  return (
    <AdminIntegrationSettings
      settingsTitle="Autopilot"
      settingsDescription={
        <>
          Enable Autopilot to pull feedback from your sources. Detected feedback will be compared to
          existing posts to identify duplicates.{' '}
          <a
            href="https://help.canny.io/en/articles/8202451-autopilot"
            target="_blank"
            rel="noopener">
            Learn more
          </a>
        </>
      }
      sections={sections}
    />
  );
};

export default compose(
  withAccessControl(
    testEveryPermission(RoutePermissions.adminSettings.integrations.autopilot),
    '/admin/settings',
  ),
)(AdminIntegrationSettingsAutopilot) as unknown as React.FC;
